document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('#news-grid');
    const loadMoreBtn = document.querySelector('#load-more-news');

    if (!grid || !loadMoreBtn) return;

    const label = loadMoreBtn.querySelector('.label');
    const spinner = loadMoreBtn.querySelector('.spinner');

    let offset = 5;
    const perPage = 4;

    loadMoreBtn.addEventListener('click', () => {
        label.hidden = true;
        spinner.hidden = false;
        loadMoreBtn.disabled = true;

        // eslint-disable-next-line no-undef, camelcase
        fetch(`${sar61n_ajax.ajax_url}?action=load_more_news&offset=${offset}&per_page=${perPage}`)
            .then(res => res.text())
            .then(html => {
                const temp = document.createElement('div');
                temp.innerHTML = html.trim();
                const cards = temp.querySelectorAll('.news-card');

                if (cards.length > 0) {
                    cards.forEach(card => grid.appendChild(card));
                    offset += perPage;
                    loadMoreBtn.disabled = false;
                    label.hidden = false;
                    spinner.hidden = true;

                    if (cards.length < perPage) loadMoreBtn.remove();
                } else {
                    loadMoreBtn.remove();
                }
            })
            .catch(() => {
                loadMoreBtn.disabled = false;
                label.hidden = false;
                spinner.hidden = true;
            });
    });
});
